import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	position: relative;
`;

export const LayoutPage = styled.div`
	display: grid;
	gap: 40px;
	width: 100%;
	background-color: white;
	padding: 0 20px 20px;
	gap: 40px;
	align-self: start;
	padding: 0 20px 20px 20px;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
